import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { getStockStatus } from '@/lib/format'

interface StockMeterProps {
    quantity: number
    minStock: number
    className?: string
}

const FILL = {
    ok: 'bg-success',
    low: 'bg-warning',
    out: 'bg-danger'
}

const StockMeter: FC<StockMeterProps> = ({ quantity, minStock, className }): ReactNode => {
    const status = getStockStatus(quantity, minStock)
    const scale = Math.max(minStock * 2, quantity, 1)
    const fill = quantity > 0 ? Math.max(4, Math.min(100, (quantity / scale) * 100)) : 0
    const marker = minStock > 0 ? Math.min(100, (minStock / scale) * 100) : null

    return (
        <div className={cn('relative h-1.5 w-full rounded-full bg-muted', className)} aria-hidden='true'>
            <div className={cn('h-full rounded-full transition-[width] duration-500', FILL[status])} style={{ width: `${fill}%` }} />

            {marker !== null && (
                <div
                    className='absolute top-1/2 h-3 w-0.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-foreground/45'
                    style={{ left: `${marker}%` }}
                />
            )}
        </div>
    )
}

export default StockMeter
